<template>
    <div class="page-score">

        <!-- GRID 1 -->
        <div class="Grid1">
            <div class="Grid1div1">
                <p id="txtscore">{{ score }}</p>
                <img id="score-image" :src="scoreImageURL" /><br>
                <p id="dontgiveup">{{ motivationalText }}</p>
                <p class="intro" v-html="$t('SCORE_PAGE.INTRO')"></p>
            </div>

            <div class="Grid1div2">
                <!-- <div class="BottomButton"> -->
                <router-link to="/game" class="myButton">{{ $t("SCORE_PAGE.TRY_AGAIN") }}</router-link>
                <!-- </div> -->
            </div>

            <div class="Grid1div3">
                <cached-video id="planktonVideoScore" unique-id="home-video-acceuil"
                    :sources='[{ path: "video/webm/470x470_BIOTHERM_SCIENCE_LIFE_PLANKTON_FINAL-VIDEO.webm", type: "video/webm" }, { path: "video/470x470_BIOTHERM_SCIENCE_LIFE_PLANKTON_FINAL-VIDEO-LR.mov", type: "video/mp4" }]'></cached-video>
            </div>

        </div>
        <!-- GRID 1 -->


        <!-- TABLEAU SCORE -->
        <div id="hide" v-if="$route.query.retail == 1">
            <div class="GridBestScore">
                <div class="GridBestScorediv1" style="font-size:14px;">
                    <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M24.9567 3.10078H20.696C20.6686 2.5305 20.636 1.97652 20.5819 1.46618C20.5493 1.18918 20.3158 0.983185 20.0386 0.983185H5.96724C5.68482 0.983185 5.45074 1.195 5.42395 1.47199C5.37504 2.00445 5.34243 2.55261 5.31506 3.10136H1.04329C0.744567 3.10136 0.5 3.34577 0.5 3.64429V4.32339C0.5 6.37115 1.30998 8.29904 2.78263 9.75442C3.78826 10.7536 5.03264 11.4437 6.39698 11.7696C7.70134 15.8651 9.92981 18.4064 12.4622 18.7212V20.7038C8.92941 20.8231 6.88087 22.1213 6.68522 24.392C6.66891 24.5438 6.72307 24.6963 6.8209 24.8045C6.92396 24.9186 7.0707 24.9838 7.22327 24.9838H18.7831C18.9351 24.9838 19.0819 24.9186 19.1855 24.8045C19.2886 24.6957 19.3375 24.5438 19.327 24.392C19.1261 22.1219 17.077 20.8236 13.55 20.7043V18.7276C16.0824 18.4069 18.3161 15.8651 19.6152 11.7702C20.9796 11.4332 22.224 10.7437 23.2238 9.75558C24.6912 8.30545 25.5012 6.37755 25.5012 4.32397V3.64487C25.5012 3.34635 25.2618 3.10194 24.9573 3.10194L24.9567 3.10078ZM3.54894 8.9828C2.28243 7.73342 1.58716 6.07729 1.58716 4.32281V4.18722H5.28827V4.22504C5.28827 4.73539 5.30458 5.24049 5.33195 5.74036C5.33719 5.80553 5.34301 5.8707 5.34301 5.94112C5.37562 6.41363 5.41347 6.88091 5.46821 7.34761C5.47927 7.44013 5.49033 7.52684 5.50081 7.61937C5.56079 8.07559 5.62601 8.53181 5.70753 8.97698C5.7186 9.04215 5.73432 9.10733 5.74538 9.16726C5.8269 9.60719 5.91949 10.0361 6.0278 10.4597C6.03304 10.4871 6.03886 10.5138 6.0441 10.5412C5.10951 10.2159 4.26168 9.68866 3.54952 8.9828H3.54894ZM17.3373 7.84224L15.2555 9.30285L16.0056 11.6055C16.0813 11.8284 16.0056 12.067 15.821 12.2031C15.6416 12.3445 15.3912 12.355 15.1962 12.2299L13.0061 10.8176L10.8161 12.2299C10.7235 12.2898 10.6257 12.3166 10.5226 12.3166C10.4032 12.3166 10.2891 12.2788 10.1913 12.2025C10.0067 12.067 9.93563 11.822 10.0067 11.6049L10.7567 9.30227L8.67495 7.84166C8.47929 7.70607 8.39777 7.46108 8.46823 7.23355C8.53869 7.00544 8.74541 6.85356 8.98473 6.85356H11.6313L12.4954 4.50204C12.577 4.29022 12.7779 4.14881 13.0061 4.14881C13.2344 4.14881 13.4359 4.29022 13.5168 4.50204L14.3809 6.85356H17.0275C17.2668 6.85356 17.473 7.00544 17.544 7.23355C17.6145 7.46167 17.5329 7.70607 17.3373 7.84224ZM24.4134 4.32281C24.4134 6.08252 23.7234 7.73924 22.4569 8.9828C21.7506 9.68342 20.9021 10.2101 19.9675 10.5359C20.0869 10.0634 20.1958 9.57461 20.2884 9.07532C20.2884 9.05903 20.2936 9.0375 20.2995 9.01538C20.3862 8.54287 20.4573 8.06511 20.5167 7.5763C20.5219 7.51113 20.533 7.44595 20.5388 7.38078C20.5929 6.90303 20.6366 6.41945 20.6692 5.93588C20.6745 5.87071 20.6745 5.80553 20.6803 5.74559C20.7071 5.24049 20.724 4.73539 20.724 4.22504V4.18722H24.414V4.32281H24.4134Z"
                            fill="white" />
                    </svg>
                    BEST SCORES
                </div>
            </div>

            <div v-for="(score, index) in bestScores" :key="'best-score-' + index"
                :class="`score-container best-score-container ${index == 2 && highlightedBestScoreIndex > 10 ? 'border-bottom-highlighted' : ''}`">
                <div class="rank">
                    {{ index + 1 }}
                </div>
                <div class="score">
                    <span v-if="highlightedBestScoreIndex == index && highlightedBestScoreIndex <= 2" class="star">
                        <i class="fa-solid fa-star"></i>
                    </span>
                    {{ score }}
                </div>
            </div>

            <div v-for="(score, index) in allScores" v-if="allScores" :key="'score-' + index"
                :class="'score-container all-scores ' + (highlightedBestScoreIndex == index + startingPosition ? 'last-scored' : '')">
                <div class="rank">{{ index + startingPosition + 1 }}</div>
                <div class="score">
                    <span v-if="highlightedBestScoreIndex == index + startingPosition" class="star">
                        <i class="fa-solid fa-star"></i>
                    </span>
                    {{ score }}
                </div>
            </div>
        </div>
        <!-- TABLEAU SCORE -->


        <!-- lien score card -->
        <div class="gridScoreCardLink">
            <div class="scoreCardLink">
                <router-link to="/scorecard" id="skipTxt" v-if="$route.query.retail != 1">
                    <svg id="scorecardicon" width="21" height="22" viewBox="0 0 21 22" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M10.0388 18.1753C10.0444 18.1809 10.0523 18.1856 10.0579 18.1913C10.0826 18.2149 10.1082 18.2375 10.1366 18.2568C10.1497 18.2653 10.1641 18.2715 10.1781 18.2795C10.2014 18.2932 10.2238 18.3068 10.2489 18.3177C10.2652 18.3243 10.2834 18.3281 10.3002 18.3342C10.3234 18.3417 10.3463 18.3507 10.3705 18.3559C10.4129 18.3644 10.4562 18.3691 10.4995 18.3691C10.5047 18.3691 10.5089 18.3677 10.514 18.3672C10.5522 18.3663 10.5904 18.363 10.6281 18.3554C10.6616 18.3488 10.6929 18.3375 10.7241 18.3262C10.7325 18.3229 10.7413 18.3215 10.7497 18.3182C10.7865 18.3031 10.8205 18.2837 10.8536 18.262C10.8559 18.2601 10.8592 18.2592 10.8615 18.2578C10.8983 18.2328 10.9318 18.205 10.9626 18.1734L17.0548 12.0059C17.3096 11.7484 17.3096 11.3301 17.0548 11.0721C16.8 10.8142 16.3873 10.8142 16.1325 11.0721L11.1517 16.1135V1.64265C11.1517 1.27811 10.8596 0.982422 10.4995 0.982422C10.1394 0.982422 9.84736 1.27811 9.84736 1.64265V16.1149L4.86615 11.0717C4.61134 10.8137 4.1986 10.8137 3.94379 11.0717C3.68898 11.3292 3.68898 11.7475 3.94379 12.0054L10.0379 18.1757L10.0388 18.1753ZM20.3478 16.7001C19.9877 16.7001 19.6957 16.9958 19.6957 17.3603V20.6615H1.30435V17.3603C1.30435 16.9958 1.01273 16.7001 0.652174 16.7001C0.291615 16.7001 0 16.9958 0 17.3603V21.3217C0 21.6863 0.292081 21.982 0.652174 21.982H20.3478C20.7079 21.982 21 21.6863 21 21.3217V17.3603C21 16.9958 20.7079 16.7001 20.3478 16.7001Z"
                            fill="white" />
                    </svg>

                    {{ $t("SCORE_PAGE.GET_MY_SCORE") }}

                </router-link>
            </div>
        </div>


        <!-- Text  -->
        <div class="GridText">
            <div class="textItem">
                <p class="intro" id="intro2">{{ $t("SCORE_PAGE.TXT") }}</p>
            </div>
        </div>

        <!-- logo 3 coeurs iPad -->
        <div class="LogoGrid">
            <div class="logo1"><img src="@/assets/BIOTHERM-PICTO-01.svg" width="100"></div>
            <div class="logo2"><img src="@/assets/BIOTHERM-PICTO-02.svg" width="100"></div>
            <div class="logo3"><img src="@/assets/BIOTHERM-PICTO-03.svg" width="100"></div>
            <div class="text1">
                <p class="textLogos" v-html='$t("SCORE_CARD_PAGE.TEXTLOGO1")'></p>
            </div>
            <div class="text2">
                <p class="textLogos" v-html='$t("SCORE_CARD_PAGE.TEXTLOGO2")'></p>
            </div>
            <div class="text3">
                <p class="textLogos" v-html='$t("SCORE_CARD_PAGE.TEXTLOGO3")'></p>
            </div>
        </div>


        <!-- logo gif -->
        <div class="GridLogo">
            <div class="LogoItem">
                <img width="180" src="@/assets/BIOTHERM_WATER_LOVER_ANIMATION_red.gif">
            </div>
        </div>

        <!-- text commited -->
        <div class="GridTextCommited">
            <div class="CommitedItem">
                <p id="commited" v-html='$t("SCORE_PAGE.COMMITED")'></p>
            </div>
        </div>


        <!-- video  -->
        <div class="GridVideo">
            <div class="VideoItem">
                <img :src="isPlaying ? pauseButtonImage : playButtonImage" @click="playVideo" class="play-button">
                <video :src="blobpath" ref="videoPlayer" id="videobiotherme" @play="isPlaying = true"
                    @pause="isPlaying = false" @ended="isPlaying = false" loop playsinline
                    poster="@/assets/poster-videofin.png">
                    <source src="/video/video-fin.mp4" type="video/mp4" />
                </video>


            </div>
        </div>


        <!-- bouton -->
        <div class="GridBottomButton">
            <div class="BottomButtonItem">
                <!-- <a href="https://www.biotherm.fr/fr_FR/our-commitments/our-blue-commitments.html" class="myButton">{{
                    $t("SCORE_PAGE.DISCOVER_MORE") }}</a> -->
                <a :href="$t('SCORE_PAGE.LINK_DISCOVER_MORE')" class="myButton">{{
                    $t("SCORE_PAGE.DISCOVER_MORE") }}</a>
            </div>
        </div>

        <!-- copyright -->
        <div class="GridCopyright">
            <p class="copyright">{{ $t("SCORE_PAGE.COPYRIGHT") }}</p>
        </div>
    </div>
</template>



<script>

import score1 from "@/assets/stars1.svg";
import score2 from "@/assets/stars2.svg";
import score3 from "@/assets/stars3.svg";
import Helper from "@/game/Helper";


export default {
    name: "pageScore",
    data() {
        return {
            isPlaying: false,
            playButtonImage: require('@/assets/btnplay.png'),
            pauseButtonImage: require('@/assets/bntpause.png'),
            score: null,
            scoreImageURL: null,
            motivationalText: null,
            blobpath: null
        };
    },
    methods: {
        getScoreImageURL(score) {
            if (score < 2000) {
                return score1;
            } else if (score < 5000) {
                return score2;
            } else {
                return score3;
            }
        },
        getMotivationalText(score) {
            if (score < 2000) {
                return this.$t("SCORE_PAGE.MOTIVATIONAL_TEXT1");
            } else if (score < 5000) {
                return this.$t("SCORE_PAGE.MOTIVATIONAL_TEXT2");
            } else {
                return this.$t("SCORE_PAGE.MOTIVATIONAL_TEXT3");
            }
        },
        playVideo() {
            if (this.isPlaying) {
                this.$refs.videoPlayer.pause();
            } else {
                this.$refs.videoPlayer.play();
            }
            this.isPlaying = !this.isPlaying;
        },
    },
    mounted() {
        const storedVideoTitle = "campagne-video-0";

        const request = window.indexedDB.open('plankton', 1);

        request.onsuccess = event => {
            const db = event.target.result;

            const transaction = db.transaction(['videos']);
            const objectStore = transaction.objectStore('videos');

            const videoStored = objectStore.get(storedVideoTitle);

            videoStored.transaction.oncomplete = event => {
                if (videoStored.result) {
                    this.blobpath = window.URL.createObjectURL(videoStored.result.blob);
                }
            };
        }


        const savedScore = window.localStorage.getItem("score");
        this.score = savedScore ? `${savedScore}` : "No score";
        // this.score = 

        // get all score and sort them
        if (!window.localStorage.getItem("allScores")) {
            Helper.defineDefaultScores();
        }

        let allScoresFromMemory = JSON.parse(window.localStorage.getItem("allScores"));
        allScoresFromMemory = allScoresFromMemory.sort(Helper.scaleOrderFunction);
        this.allScores = [];


        // get highlighted last scored
        for (let i = 0; i < allScoresFromMemory.length; i++) {
            if (allScoresFromMemory[i] == this.score) {
                this.highlightedBestScoreIndex = i;
                break;
            }
        }

        this.startingPosition = 0;
        this.endingPosition = allScoresFromMemory.length;

        if (this.highlightedBestScoreIndex > 10) {
            this.startingPosition = this.highlightedBestScoreIndex - 11;
        }

        if (allScoresFromMemory.length > 10) {
            if (allScoresFromMemory.length > 20) {
                this.startingPosition = this.highlightedBestScoreIndex - 1;
                if (this.highlightedBestScoreIndex < allScoresFromMemory.length - 9) {
                    this.endingPosition = this.highlightedBestScoreIndex + 8;
                }
                else {
                    this.endingPosition = allScoresFromMemory.length;
                }
            }
            else {
                if (this.highlightedBestScoreIndex >= 4 && (this.highlightedBestScoreIndex - allScoresFromMemory.length >= 8)) {
                    this.startingPosition = this.highlightedBestScoreIndex - 1;
                }
                else {
                    this.startingPosition = this.highlightedBestScoreIndex - 1;
                    if (this.startingPosition <= 3) this.startingPosition = 3;
                }

                this.endingPosition = allScoresFromMemory.length;
                if (this.endingPosition - this.highlightedBestScoreIndex > 8) this.endingPosition = this.highlightedBestScoreIndex + 8
            }
        }
        else {
            if (this.highlightedBestScoreIndex > 2) {
                this.startingPosition = 3;
            }
        }
        if (this.highlightedBestScoreIndex <= 10) {
            this.startingPosition = 3;
            if (allScoresFromMemory.length > 10) {
                this.endingPosition = 10;
            } else {
                this.endingPosition = allScoresFromMemory.length;
            }
        }

        for (let i = this.startingPosition; i < allScoresFromMemory.length && i < this.endingPosition; i++) {
            this.allScores.push(allScoresFromMemory[i]);
        }

        this.bestScores = [];

        for (let i = 0; i < allScoresFromMemory.length && i < 3; i++) {
            this.bestScores.push(allScoresFromMemory[i]);
        }

        this.$root.showNav = false;
        this.scoreImageURL = this.getScoreImageURL(parseInt(savedScore, 10));
        this.motivationalText = this.getMotivationalText(parseInt(savedScore, 10));
    },
    beforeUnmount() {
        this.$root.showNav = true;
    },
};
</script>




<style scoped>
/* iPhone SE */
@media only screen and (max-width: 320px) {
    .play-button {
        position: relative;
        top: 80%;
        left: 5%;
        cursor: pointer;
        z-index: 10;
        bottom: -150px;
    }
}

/* iPhone */
@media only screen and (max-width: 600px) and (min-width: 321px) {
    .play-button {
        position: relative;
        top: 80%;
        left: 5%;
        /* transform: translate(-50%, -50%); */
        cursor: pointer;
        z-index: 10;
        bottom: -200px;
    }
}

.page-score {
    background-image: radial-gradient(70% 40% at 50% 47%,
            #063770 0%,
            #073aff00 100%),
        radial-gradient(113% 91% at 17% -2%, #05376b 1%, #ff000000 99%),
        radial-gradient(142% 91% at 83% 7%, #025e9f 1%, #ff000000 99%),
        radial-gradient(142% 91% at -6% 74%, #0b5394 1%, #ff000000 99%),
        radial-gradient(142% 91% at 111% 84%, #0e85ce 0%, #0e85ce 100%);

    overscroll-behavior-y: contain;
    padding: 0;
    min-height: 100vh;

}


/*Grid 1*/
.Grid1 {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 260px 91px 400px;
    padding-top: 50px;
}

.Grid1div2 {
    grid-area: 2 / 1 / 3 / 2;
    justify-self: center;
    align-self: center;
}

.intro {
    width: auto;
    font-size: 14px;
}


/*link score card*/
.gridScoreCardLink {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 75px;
}

.scoreCardLink {
    grid-area: 1 / 1 / 2 / 2;
    justify-self: center;
    align-self: center;
}


.GridText {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 100px;
}

.textItem {
    grid-area: 1 / 1 / 2 / 2;
    justify-self: center;
    align-self: center;
    padding: 0 20px 0 20px;
}

.GridLogo {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 240px;
}

.LogoItem {
    grid-area: 1 / 1 / 2 / 2;
    justify-self: center;
    align-self: center;
}


.GridTextCommited {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 65px;
}

.CommitedItem {
    grid-area: 1 / 1 / 2 / 2;
    justify-self: center;
    align-self: center;
    padding: 0 20px 0 20px;
}

.GridVideo {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
}

.VideoItem {
    grid-area: 1 / 1 / 2 / 2;
    justify-self: center;
    align-self: center;
}

.GridBottomButton {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 80px;
}

.BottomButtonItem {
    grid-area: 1 / 1 / 2 / 2;
    justify-self: center;
    align-self: center;
}


.GridCopyright {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
}






#txtscore {
    text-align: center;
    font-family: "FuturaLTMedium";
    color: white;
    font-style: normal;
    font-weight: 400;
    font-size: 40px;
    line-height: 40px;
    letter-spacing: 0.8px;
    margin: 0;
}

#scorecardicon {
    padding-right: 15px;
    top: 10px;
    position: relative;
}

#videosccore {
    width: 100%;

}

#planktonVideoScore {
    width: 100%;
}

/* .play-button {
    position: relative;
    top: 80%;
    left: 5%;
    cursor: pointer;
    z-index: 10;
    bottom: -200px;
} */

#score-image {
    width: 100px;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.myButton {
    width: 120px;
}

#videobiotherme {
    width: 100%;
}

#hide {
    display: none;
}

.LogoGrid {
    display: none;
}




@media screen and (min-width: 40em) {

    /*Grid 1*/
    .Grid1 {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 260px 95px 545px;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
    }

    .Grid1div1 {
        grid-area: 1 / 1 / 2 / 2;
        justify-self: center;
        align-self: center;
        padding-top: 40px;
    }

    .Grid1div2 {
        grid-area: 2 / 1 / 3 / 2;
        justify-self: center;
        align-self: center;
    }

    .Grid1div3 {
        grid-area: 3 / 1 / 4 / 2;
        justify-self: center;
        align-self: center;
    }

    .myButton2 {
        background-color: #00263a;
        border-radius: 42px;
        /* display: inline-block; */
        cursor: pointer;
        color: #ffffff;
        font-family: "FuturaLTLight";
        font-size: 11px;
        letter-spacing: 0.6px;
        padding: 17px 32px;
        text-decoration: none;
        position: relative;
        left: 0;
        right: 0;
        text-align: center;
        width: 95px;
        z-index: 0;
    }

    /*Grid 1*/

    /*tableau score*/
    #hide {
        display: grid;
    }

    .GridBestScore {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 40px;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        background: #00263A;
        width: 80%;
        margin: auto;
    }

    .GridBestScorediv1 {
        grid-area: 1 / 1 / 2 / 2;
        justify-self: center;
        align-self: center;
        font-family: "FuturaLTMedium";
        color: white;
        font-size: 16px;

    }

    .score-container {
        margin: auto;
        display: grid;
        width: 80%;
        grid-template-columns: 30px 1fr;
        grid-template-rows: 40px;
        text-align: center;
        font-family: "FuturaLTLight";
        color: white;
        font-size: 20px;
    }

    .all-scores {
        color: rgba(255, 255, 255, 0.271);
    }

    .star {
        position: absolute;
        left: -50px;
    }

    .last-scored {
        color: white;
    }

    .border-bottom-highlighted {
        border-bottom: solid 1px white;
    }

    .score-container:nth-child(2n) {
        background: #3594C9;
    }

    .rank {
        grid-area: 1 / 1 / 2 / 2;
        align-self: center;
    }

    .score {
        grid-area: 1 / 2 / 2 / 3;
        justify-self: center;
        align-self: center;
        position: relative;
    }

    /*tableau score*/


    /* .gridScoreCardLink {
        display: none;
    } */





    #commited {
        padding: 0 100px 0 100px;
    }







    .GridLogo {
        display: none;
    }





    .LogoGrid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(2, 30px);
        grid-column-gap: 20px;
        grid-row-gap: 45px;
        padding-top: 80px;
        padding-bottom: 40px;
        padding-right: 20px;
        padding-left: 20px;
    }

    .logo1 {
        grid-area: 1 / 1 / 2 / 2;
        justify-self: center;
        align-self: center;
    }



    .logo2 {
        grid-area: 1 / 2 / 2 / 3;
        justify-self: center;
        align-self: center;
    }

    .logo3 {
        grid-area: 1 / 3 / 2 / 4;
        justify-self: center;
        align-self: center;
    }

    .textLogos {
        text-align: center;
        font-family: "FuturaLTLight";
        color: white;
        font-size: 20px;
    }

    .text1 {
        grid-area: 2 / 1 / 3 / 2;
        justify-self: center;
        align-self: center;

    }

    .text2 {
        grid-area: 2 / 2 / 3 / 3;
        justify-self: center;
        align-self: center;

    }

    .text3 {
        grid-area: 2 / 3 / 3 / 4;
        justify-self: center;
        align-self: center;

    }

    .scoreRow4 {
        display: none;
    }

    .scoreRow5 {
        display: none;
    }

    .intro {
        width: auto;
        font-size: 20px;
        line-height: 20px;
        padding: 0 100px 0 100px;
    }

    .gridScore {
        grid-template-rows: 263px 140px 555px;
    }

    #intro2 {
        font-size: 20px;
        line-height: 26px;
        position: relative;
        width: 567px;
        padding-top: 20px;
    }




    .play-button {
        position: relative;
        top: 80%;
        left: 5%;
        cursor: pointer;
        z-index: 10;
        top: 436px;
    }



    .parent {
        display: grid;
        grid-template-columns: 30px 1fr;
        grid-template-rows: repeat(11, 1fr);
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        font-family: "FuturaLTMedium";
        color: white;
        font-size: 16px;
    }

    /*ligne best score*/
    .div1 {
        grid-area: 1 / 1 / 2 / 3;
        justify-self: center;
        background: #00263A;
        width: 100%;
        text-align: center;
        padding: 10px 0 10px 0;
        border-bottom: 1px solid white;

    }

    .div2 {
        grid-area: 2 / 1 / 3 / 2;
        justify-self: center;
        padding: 10px 0 10px 0;

    }

    .div3 {
        grid-area: 2 / 2 / 3 / 3;
        justify-self: center;
        padding: 10px 0 10px 0;

    }

    .div4 {
        grid-area: 3 / 1 / 4 / 2;
        justify-self: center;
        padding: 10px 0 10px 0;
        background: #3594C9;
        width: 100%;
        text-align: center;
    }

    .div5 {
        grid-area: 3 / 2 / 4 / 3;
        justify-self: center;
        padding: 10px 0 10px 0;
        background: #3594C9;
        width: 100%;
        text-align: center;
    }

    .div6 {
        grid-area: 4 / 1 / 5 / 2;
        justify-self: center;
        padding: 10px 0 10px 0;
    }

    .div7 {
        grid-area: 4 / 2 / 5 / 3;
        justify-self: center;
        padding: 10px 0 10px 0;
    }

    .div8 {
        grid-area: 5 / 1 / 6 / 2;
        justify-self: center;
        padding: 10px 0 10px 0;
        background: #3594C9;
        width: 100%;
        text-align: center;
    }

    .div9 {
        grid-area: 5 / 2 / 6 / 3;
        justify-self: center;
        padding: 10px 0 10px 0;
        background: #3594C9;
        width: 100%;
        text-align: center;
    }

    .div10 {
        grid-area: 6 / 1 / 7 / 2;
        justify-self: center;
        padding: 10px 0 10px 0;
    }

    .div11 {
        grid-area: 6 / 2 / 7 / 3;
        justify-self: center;
        padding: 10px 0 10px 0;
    }

    .div12 {
        grid-area: 7 / 1 / 8 / 2;
        justify-self: center;
        padding: 10px 0 10px 0;
        background: #3594C9;
        width: 100%;
        text-align: center;
    }

    .div13 {
        grid-area: 7 / 2 / 8 / 3;
        justify-self: center;
        padding: 10px 0 10px 0;
        background: #3594C9;
        width: 100%;
        text-align: center;
    }

    .div14 {
        grid-area: 8 / 1 / 9 / 2;
        justify-self: center;
        padding: 10px 0 10px 0;
    }

    .div15 {
        grid-area: 8 / 2 / 9 / 3;
        justify-self: center;
        padding: 10px 0 10px 0;
    }

    .div16 {
        grid-area: 9 / 1 / 10 / 2;
        justify-self: center;
        padding: 10px 0 10px 0;
        background: #3594C9;
        width: 100%;
        text-align: center;
    }

    .div17 {
        grid-area: 9 / 2 / 10 / 3;
        justify-self: center;
        padding: 10px 0 10px 0;
        background: #3594C9;
        width: 100%;
        text-align: center;
    }

    .div18 {
        grid-area: 10 / 1 / 11 / 2;
        justify-self: center;
        padding: 10px 0 10px 0;
    }

    .div19 {
        grid-area: 10 / 2 / 11 / 3;
        justify-self: center;
        padding: 10px 0 10px 0;
    }

    .div20 {
        grid-area: 11 / 1 / 12 / 2;
        justify-self: center;
        padding: 10px 0 10px 0;
        background: #3594C9;
        width: 100%;
        text-align: center;
    }

    .div21 {
        grid-area: 11 / 2 / 12 / 3;
        justify-self: center;
        padding: 10px 0 10px 0;
        background: #3594C9;
        width: 100%;
        text-align: center;
    }

    /* .myButton {
        display: none;
    } */

}
</style>